"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
const preferences_1 = require("@completeanatomy/preferences");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const options = [
    {
        name: i18n_1.Strings.settings.preferences.features.language.names.English,
        nativeName: i18n_1.Strings.settings.preferences.features.language.options.English,
        locale: 'en',
    },
    {
        name: i18n_1.Strings.settings.preferences.features.language.names.French,
        nativeName: i18n_1.Strings.settings.preferences.features.language.options.French,
        locale: 'fr',
    },
    {
        name: i18n_1.Strings.settings.preferences.features.language.names.German,
        nativeName: i18n_1.Strings.settings.preferences.features.language.options.German,
        locale: 'de',
    },
    {
        name: i18n_1.Strings.settings.preferences.features.language.names.Spanish,
        nativeName: i18n_1.Strings.settings.preferences.features.language.options.Spanish,
        locale: 'es',
    },
];
function LanguageSelector() {
    const { i18n } = (0, i18n_1.useTranslation)();
    const bridge = (0, bridge_1.useBridge)();
    const theme = (0, styled_components_1.useTheme)();
    const [selectedLanguage, setSelectedLanguage] = (0, react_1.useState)(options.find(option => option.locale === i18n.language) || options[0]);
    const [lastLanguage, setLastLanguage] = (0, react_1.useState)(selectedLanguage);
    const [open, setOpen] = (0, react_1.useState)(false);
    const [isDialogOpen, setIsDialogOpen] = (0, react_1.useState)(false);
    const toggleDropdown = () => {
        setOpen(prev => !prev);
    };
    const onConfirm = () => {
        setLastLanguage(lastLanguage);
        i18n.changeLanguage(selectedLanguage.locale);
        bridge === null || bridge === void 0 ? void 0 : bridge.setAppLanguage(selectedLanguage.locale);
        setOpen(false);
        window.setTimeout(() => {
            window.location.reload();
        }, 100);
    };
    const onCancel = () => {
        setIsDialogOpen(false);
        setSelectedLanguage(lastLanguage);
    };
    const onItemClick = (lang) => {
        return () => {
            if (lang.locale === selectedLanguage.locale) {
                setOpen(false);
                return;
            }
            setSelectedLanguage(lang);
            setIsDialogOpen(true);
            setOpen(false);
        };
    };
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsxs)(Button, { onClick: toggleDropdown, children: [(0, i18n_1.Localized)(selectedLanguage.nativeName), (0, jsx_runtime_1.jsx)(ChevronDown, { children: (0, jsx_runtime_1.jsx)(StyledIcon, { name: ui_1.Icons.Arrow_Down }) })] }), open && ((0, jsx_runtime_1.jsx)(Dropdown, { children: (0, jsx_runtime_1.jsx)(List, { children: options.map(lang => ((0, jsx_runtime_1.jsxs)(ListItem, { selected: lang.locale === selectedLanguage.locale, onClick: onItemClick(lang), children: [(0, i18n_1.Localized)(lang.nativeName), lang.locale === selectedLanguage.locale && ((0, jsx_runtime_1.jsx)(CheckIcon, { children: (0, jsx_runtime_1.jsx)(StyledIcon, { name: ui_1.Icons.Checkmark }) }))] }, lang.locale))) }) })), isDialogOpen && ((0, jsx_runtime_1.jsx)(preferences_1.ChangeLanguageDialog, { isOpen: true, language: selectedLanguage.nativeName, onCancel: onCancel, onConfirm: onConfirm, dialogText: {
                    cancelBtnText: (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.features.language.dialog.cancelWeb),
                    confirmBtnText: (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.features.language.dialog.confirmWeb),
                    title: (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.features.language.dialog.title, {
                        language: selectedLanguage.nativeName,
                    }),
                }, styles: {
                    zIndex: 999,
                    backgroundColor: theme.backgroundWithOpacity,
                } }))] }));
}
exports.default = LanguageSelector;
const Wrapper = styled_components_1.default.div `
  position: relative;
  display: inline-block;
  color: white;

  margin-left: 16px;

  font-family: 'Elsevier Sans', sans-serif;
`;
const Button = styled_components_1.default.button `
  background-color: ${({ theme }) => theme.grasshopper.background};
  padding: 8px;

  min-width: 100px;
  width: 100%;

  border: 1px solid ${({ theme }) => theme.grasshopper.borders.whiteSecondary};
  border-radius: 4px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  gap: 4px;

  font-size: 16px;
  line-height: 1.5;
  font-family: 'Elsevier Sans', sans-serif;

  color: ${({ theme }) => theme.whiteSecondary};
`;
const Dropdown = styled_components_1.default.div `
  position: absolute;
  top: 100%;
  margin-top: -42px;

  background-color: ${({ theme }) => theme.grasshopper.background};

  width: 100%;

  border: 1px solid ${({ theme }) => theme.grasshopper.borders.whiteSecondary};
  border-radius: 4px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  color: white;

  ${ui_1.deviceMainScreenLandscape.mobile `
    margin-top: -94px;
  `}
`;
const List = styled_components_1.default.ul `
  list-style: none;
  margin: 0;
  padding: 0;

  width: 100%;
`;
const ListItem = styled_components_1.default.li `
  padding: 8px;
  margin: 0;

  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background-color: transparent;

  font-size: 16px;
  line-height: 1.5;
  font-family: 'Elsevier Sans', sans-serif;
  color: ${({ theme }) => theme.whiteSecondary};

  border-radius: 4px;

  &:hover {
    background-color: ${({ theme }) => theme.grasshopper.menuButtons.hoverBackground};
  }
`;
const ChevronDown = styled_components_1.default.div `
  width: 20px;
  height: 20px;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 100%;
  height: 100%;
`;
const CheckIcon = styled_components_1.default.div `
  width: 20px;
  height: 20px;
`;
